import { Directive, effect, inject, Input, signal, TemplateRef, ViewContainerRef } from '@angular/core';
import { Permission } from '../models/permissions';
import { PermissionsService } from '../services/permissions.service';

@Directive({
  selector: '[hasPermissions]',
})
export class PermissionsDirective {
  private permissionsService = inject(PermissionsService);
  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);

  private requiredPermissionsSignal = signal<Permission[]>([]);

  @Input('hasPermissions')
  set requiredPermissions(value: Permission[]) {
    this.requiredPermissionsSignal.set(value || []);
  }

  constructor() {
    effect(() => {
      const permissions = this.requiredPermissionsSignal();
      const hasPermission = this.permissionsService.hasPermissions(permissions)();
      if (hasPermission) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
